import React, {useState} from 'react'
import ReactDOM from 'react-dom'

import {DatePicker, Modal, Form} from "antd";

import moment from 'moment'

// Same behaviour as frmCardAccess in the Windows app: when the property has
// "Allow Edit Access Card DateTime" ticked, let the user adjust the card validity
// before it is written.
export function isCardDateTimeEditable()
{
    try
    {
        let gvCustomSetting = JSON.parse(localStorage.getItem('customsetting'));

        if (gvCustomSetting !== null && gvCustomSetting !== undefined)
        {
            if (gvCustomSetting.data !== null && gvCustomSetting.data !== undefined)
            {
                return gvCustomSetting.data.allowEditAccessCardDateTime === true;
            }
        }
    }
    catch (e)
    {
    }

    return false;
}

// Reads the setting fresh from the server so a change made in the Windows app applies
// without logging in again. Falls back to the cached localStorage copy when offline.
export async function getCardDateTimeEditable()
{
    try
    {
        let obj = JSON.parse(localStorage.getItem('currentproperty'));

        if (obj !== null && obj !== undefined)
        {
            let res = await fetch(`/api/hotels/${obj.id}/settings`, {cache: 'no-store'});

            if (res.ok)
            {
                let settingList = await res.json();

                for (let x of settingList)
                {
                    if (x.type === "custom")
                    {
                        localStorage.setItem('customsetting', JSON.stringify(x));
                        break;
                    }
                }
            }
        }
    }
    catch (e)
    {
    }

    return isCardDateTimeEditable();
}

export function validateCardDateTime(start, end)
{
    if (!start || !end || !moment(start).isValid() || !moment(end).isValid())
        return 'Please select both check-in and check-out date/time.';

    if (!moment(end).isAfter(moment(start)))
        return 'Check-out date/time must be after check-in date/time.';

    return '';
}

function CardDateTimeModal(props) {
    const [start, setStart] = useState(moment(props.start).seconds(0).milliseconds(0));
    const [end, setEnd] = useState(moment(props.end).seconds(0).milliseconds(0));
    const [visible, setVisible] = useState(true);

    const message = validateCardDateTime(start, end);

    const close = (result) => {
        setVisible(false);
        props.onClose(result);
    }

    return (
        <Modal
            title={`Issue Access Card${props.roomNo ? ' - Unit ' + props.roomNo : ''}`}
            visible={visible}
            okText="Write Card"
            okButtonProps={{disabled: message !== ''}}
            onOk={() => close({start: start, end: end})}
            onCancel={() => close(null)}
            afterClose={props.afterClose}
            maskClosable={false}
            destroyOnClose
        >
            <Form layout="vertical">
                <Form.Item label="Check-In">
                    <DatePicker
                        allowClear={false}
                        format="YYYY-MM-DD HH:mm"
                        showTime={{format: 'HH:mm'}}
                        value={start}
                        onChange={(v) => setStart(v)}
                        style={{width: '100%'}}
                    />
                </Form.Item>
                <Form.Item
                    label="Check-Out"
                    validateStatus={message !== '' ? 'error' : ''}
                    help={message !== '' ? message : undefined}
                >
                    <DatePicker
                        allowClear={false}
                        format="YYYY-MM-DD HH:mm"
                        showTime={{format: 'HH:mm'}}
                        value={end}
                        onChange={(v) => setEnd(v)}
                        style={{width: '100%'}}
                    />
                </Form.Item>
            </Form>
        </Modal>
    );
}

// Resolves to {start, end} (moment objects) when the user confirms, or null when cancelled.
export function askCardDateTime(start, end, roomNo)
{
    return new Promise((resolve) => {
        const div = document.createElement('div');
        document.body.appendChild(div);

        const cleanup = () => {
            ReactDOM.unmountComponentAtNode(div);
            if (div.parentNode)
                div.parentNode.removeChild(div);
        }

        ReactDOM.render(
            <CardDateTimeModal
                start={start}
                end={end}
                roomNo={roomNo}
                onClose={resolve}
                afterClose={cleanup}
            />,
            div
        );
    });
}
